import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';

// Components 

import HeaderSection from '../header/HeaderSection';
import FilesList from './FilesList';
import Footer from '../footer/Footer';

// Props type definition
interface FilesSectionProps {
    isMobile: boolean;
}

const FilesSection: React.FC<FilesSectionProps> = ({ isMobile }) => {

    const dispatch = useAppDispatch(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const mode = useAppSelector(state => state.fileExplorer.mode);

    // Define width and height based on isMobile prop
    const width = isMobile ? '95%' : '73%'; // Full width on mobile, adjusted percentage on desktop
    // Height will be handled by flexGrow in the parent container for mobile
    const height = isMobile ? 'auto' : '95%'; 
    const flexGrow = isMobile ? 1 : undefined; // Allow this section to grow on mobile
    const margin = isMobile ? 1 : 1; // Consistent margin
    const padding = isMobile ? 1 : 0; // Add padding on mobile

    return (

        <Box 
        sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            width: width,
            height: height, 
            flexGrow: flexGrow, // Allow growth on mobile
            minHeight: 0, // Prevent flexbox overflow issues
            borderRadius: isMobile ? 1 : 2, // Smaller radius on mobile
            backgroundColor: colors?.container,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)', // Softer shadow
            margin: margin, // Use margin for spacing
            padding: padding, // Add padding on mobile
            overflow: 'hidden', // Hide overflow, children will handle scrolling
        }}>

            <HeaderSection />

            <FilesList />

            <Footer /> 
            
        </Box>

    );

};

export default FilesSection;